// Module
var code = "<div id=\":elementId\"> <h4>Currencies</h4> </div>";
// Exports
export default code;